
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#4A4A4A"}},[_c('path',{attrs:{"d":"M14.25 6l-.001-4.25H10l-.077-.004A.75.75 0 0110 .25l4.999.001.077.004A.75.75 0 0115.75 1L15.75 6a.75.75 0 01-1.5 0z"}}),_c('path',{attrs:{"d":"M14.526.418a.75.75 0 011.056 1.056l-.052.056-6 6a.75.75 0 11-1.06-1.06l6-6 .056-.052z"}}),_c('path',{attrs:{"d":"M13.75 14.333a1.418 1.418 0 01-1.417 1.417H1.667a1.418 1.418 0 01-1.41-1.276l-.007-.141V3.667c0-.376.15-.736.415-1.002l.104-.094c.252-.206.57-.321.898-.321h6l.076.004a.75.75 0 010 1.492l-.076.004H1.75v10.5h10.5V8.333a.75.75 0 011.5 0v6z"}})])])
          )
        }
      }
    